import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic DŽUDO SPREMAN reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-275" data-mp="3fym70jljx03t">
      <div className="mx-auto max-w-6xl" data-id="element-276" data-mp="3azjetzqo6od9">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-277" data-mp="3ayqdjeahcr2i">
          Šta kažu <em className="text-red-700" data-id="element-278" data-mp="31zwcnbq49ej5">treneri</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-279" data-mp="31yl7b7h0vypx">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-280" data-mp="2x2ml9qj62sso">
              <div className="text-sm text-amber-500" aria-label="5 od 5 zvezdica" data-id="element-281" data-mp="2s39skp5m6ri6">
                <span aria-hidden="true" data-id="element-282" data-mp="v859txg9hd2s">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-283" data-mp="q9u15q1pd8m5">
                „{item.quote}“
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-284" data-mp="h8197snheoml">
                <span className="font-semibold text-slate-900" data-id="element-285" data-mp="m5b2jjdzrkfp">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-286" data-mp="78abzj7jdvit"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}